import React from 'react';
import Tippy, { TippyProps } from '@tippyjs/react';
import './styles.scss';
import { TooltipType } from '../inputs';

interface TsrTooltipProps {
    disabled?: boolean | 'inputOnly';
    type?: TooltipType;
    icon?: boolean;
    className?: string;
}

const TsrTooltip: React.FC<TsrTooltipProps & TippyProps> = (props): JSX.Element => {
    const { children, icon, disabled, singleton, ...restProps } = props;

    const popperOptions = {
        modifiers: [
            {
                name: 'flip',
                options: {
                    fallbackPlacements: ['bottom', 'top', 'right', 'left'],
                },
            },
            {
                name: 'preventOverflow',
                options: {
                    mainAxis: true,
                    tether: true,
                },
            },
        ],
    };

    return (
        <Tippy
            singleton={singleton}
            theme={props.type || TooltipType.Info}
            disabled={disabled}
            arrow={false}
            placement="bottom-end"
            popperOptions={popperOptions}
            duration={0}
            delay={[200, 0]}
            className={props.className}
            {...restProps}
        >
            {props.icon ? children : <div>{children}</div>}
        </Tippy>
    );
};

export default TsrTooltip;
